// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Extensions\PilotsInitialDataExtension.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { InitialData, InitialDataData, InitialDataOptions } from 'data/models/InitialData';
import { Pilot, PilotData, PilotOptions } from 'data/models/Pilot';
import { PilotAgency, PilotAgencyData, PilotAgencyOptions } from 'data/models/PilotAgency';

// PilotsInitialDataData is the class that PilotsInitialData serializes to/from
export interface PilotsInitialDataData {
    Id : number;
	
    InitialData : InitialDataData | null;
    PilotAgencies : PilotAgencyData[] | null;
    Pilots : PilotData[] | null;
	
}

// PilotsInitialDataOptions is the class which may be passed to the PilotsInitialData constructor to define optional initial data values
export interface PilotsInitialDataOptions {
    Id : number;
	
    InitialData? : InitialDataOptions | null;
    PilotAgencies? : PilotAgencyOptions[] | null;
    Pilots? : PilotOptions[] | null;
	
}

export class PilotsInitialData {
    public Id : DataSignal<number>;
	
    public InitialData : DataSignal<InitialData | null>;
    public PilotAgencies : SDataArray<PilotAgency>;
    public Pilots : SDataArray<Pilot>;
	

    constructor();
    constructor(data : PilotsInitialDataOptions);
    constructor(data: PilotsInitialDataOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.InitialData = S.value<InitialData | null>(null);
        this.PilotAgencies = SArray<PilotAgency>([]);
        this.Pilots = SArray<Pilot>([]);
	    
    }

    static key(obj : PilotsInitialData) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotsInitialDataOptions) {
        return obj.Id;
    }

    static update(obj : PilotsInitialData, data : PilotsInitialDataOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotsInitialData.ts